import Component from '../abstracts/Component';

/**
 * This component manage promocode component
 */
export default class PromocodeComponent extends  Component{
  static get SELECTORS(){
    return {
      voucherFormSelector : '.js-voucher-form',
      applyBtn : '.js-apply-voucher',
      voucherErrorSelector : '.js-voucher-error'
    };
  }
  
  bindEvents(){
	  
	  $(PromocodeComponent.SELECTORS.applyBtn).on('click', function(e) {
		  
		  var form = $(this).closest(PromocodeComponent.SELECTORS.voucherFormSelector);
		  var href = $(form).prop('action');
		  
	      e.preventDefault();
	      $.ajaxSetup({
	          headers:
	              { 'X-CSRF-TOKEN': $(".csrf").val() }
	      });
	      $.ajax({
	        url: href,
	        type: 'POST',
	        data: $(form).serializeArray(),
	        dataType: "json"
	      }).done(function(json) {
	        if (json.responseStatus == 200) {
	          //reload page to display totals updates
	          location.reload();
	        } else {
	          $(PromocodeComponent.SELECTORS.voucherErrorSelector).html(json.response);
	          $(".js-voucher-code").addClass( "error" );

	        }
	      }).fail(function(xhr) {
	        console.log(xhr);
	        $(".js-voucher-code").addClass( "error" );
	        $(PromocodeComponent.SELECTORS.voucherErrorSelector).text('error');
	      });

	    });

  }

  


  render(){
    super.render();
    this.bindEvents();

  }
}
